import { IconMapBus16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { UIText1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './GeoTravelTime.css';
import { ETransportType } from '../../../types/geo';

interface IGeoTravelTimeProps {
  transportType: ETransportType;
  time: number;
  isRedesign?: boolean;
}

export const GeoTravelTime: React.FC<IGeoTravelTimeProps> = ({ transportType, time, isRedesign }) => {
  const Icon = transportType === ETransportType.Walk ? IconMapWalk16 : IconMapBus16;

  return (
    <div className={styles['container']}>
      <div data-name={transportType} className={styles['icon']}>
        <Icon display="block" color="icon-secondary-default" />
      </div>

      <UIText1 display="inline" color="text-secondary-default">
        {time} {isRedesign && 'мин.'}
      </UIText1>
    </div>
  );
};
